module.exports = __webpack_public_path__ + "img/sand-rock-big-01.3a28a394.png";